const howToSubmit = {
  visible_how_to_submit: false,
  visible_terms: false,
}

export default howToSubmit
